'use client';

import { Message } from '@/lib/copilot/message';
import { AssistantMessage } from './AssistantMessage';
import { MessageInternalisation } from './MessageInternalisation';
import { MessageRow } from './MessageRow';
import { StatusMessage } from './StatusMessage';
import { UserMessage } from './UserMessage';
import { LoadingMessage } from './LoadingMessage';

type ChatMessageProps = {
  message: Message;
  isLast: boolean;
};

/**
 * Determines which message component to render based on message role
 */
export function ChatMessage({ message, isLast }: ChatMessageProps) {
  switch (message.role) {
    case 'agent':
      return (
        <>
          {/* {message.internalisation && (
            <MessageRow orientation="left">
              <MessageInternalisation 
                internalisation={message.internalisation} 
                status={message.status} 
              />
            </MessageRow>
          )} */}
          {message.content !== null && (
            <MessageRow orientation="left">
              <AssistantMessage message={message} isLast={isLast} />
            </MessageRow>
          )}
          {message.status == 'in_progress' && message.content === null && (
            <MessageRow orientation="left">
              <LoadingMessage />
            </MessageRow>
          )}
        </>
      );
      
    case 'status':
      return <StatusMessage message={message} />;
      
    case 'user':
      return (
        <MessageRow orientation="right">
          <UserMessage message={message} isLast={isLast} />
        </MessageRow>
      );
      
    default:
      throw new Error(`Unknown message type: ${message.role}`);
  }
}
